import React from 'react';
import { theme } from '@fiverr-private/theme';
import { L1_ICON_SIZES } from '../../constants';
import type { L1IconType } from '../../types';

const FileL1Icon = ({ size = 'sm', color = 'currentColor' }: L1IconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={L1_ICON_SIZES[size]}
    height={L1_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 19 25"
  >
    <path d="M5.71 8.169a.75.75 0 0 0 0 1.5h1.223a.75.75 0 1 0 0-1.5zM4.96 13.807a.75.75 0 0 1 .75-.75h7.333a.75.75 0 1 1 0 1.5H5.71a.75.75 0 0 1-.75-.75M5.71 17.946a.75.75 0 0 0 0 1.5h7.333a.75.75 0 1 0 0-1.5z" />
    <path
      fillRule="evenodd"
      d="m18.683 7.697-.001.039V21.14a3.194 3.194 0 0 1-3.195 3.195H3.266A3.195 3.195 0 0 1 .07 21.14V4.03A3.194 3.194 0 0 1 3.266.836h8.556c.219 0 .416.093.553.243l6.064 6.065c.15.137.244.334.244.553M3.266 2.336A1.694 1.694 0 0 0 1.57 4.03v17.11a1.694 1.694 0 0 0 1.695 1.695h12.221a1.694 1.694 0 0 0 1.695-1.695V8.447h-4.138a1.97 1.97 0 0 1-1.972-1.973V2.336zm12.855 4.61-3.55-3.549v3.077a.47.47 0 0 0 .473.473z"
      clipRule="evenodd"
    />
  </svg>
);
FileL1Icon.displayName = 'FileL1Icon';
export default FileL1Icon;
